function initializeSuperscripts() {

  const listOfStrings = [
    {
      text: '®'
    },
    {
      text: '™'
    },
    {
      regex: '\\^',
      text: '^' 
    },
    {
      text: '©'
    },
    {
      text: '†'
    },
    {
      text: '‡'
    }
  ];

  function recurse(element)
  {
      if(element.nodeName == 'SUP' || element.classList?.contains('nosuperscript'))
          return;
      
      if (element.childNodes.length > 0) 
          for (var i = 0; i < element.childNodes.length; i++) 
              recurse(element.childNodes[i]);

      if (element.nodeType == Node.TEXT_NODE && element.nodeValue.trim() != '') 
          injectSups(element);
  }
  
  function injectSups(element)
  {
    var elJQ = $(element);
    
    $.each(listOfStrings, function( key, value ) {
      if(value.regex !== undefined)
      {
        var orig = elJQ.text();
        var rep = orig.replace(new RegExp(value.regex, 'g'), `<sup>${value.text}</sup>`);
        if(orig != rep) 
            elJQ.replaceWith(rep);
      }
      else
      {
        var orig = elJQ.text();
        var rep = orig.replace(new RegExp(value.text, 'g'), `<sup>${value.text}</sup>`);
        if(orig != rep) 
            elJQ.replaceWith(rep);
      }
    });
  }
      
  var html = document.getElementsByTagName('html')[0];
  recurse(html);
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeSuperscripts()
})





function getCookie(userName) {
  const cookieValue = document.cookie.match('(^|;)\\s*' + userName + '\\s*=\\s*([^;]+)');
  return cookieValue ? cookieValue.pop() : null;
}


async function getNextlyUrl() {
  try {
    var response = await $.ajax({
      url: '/api/Login/getNextlyDomain',
      type: 'GET',
      contentType: 'application/json',
    });
    return response.link
  } catch (error) {
    console.error('Error:', error);
    return ''
  }
}

$(document).ready(function () {
  getNextlyUrl()
    .then(res => {      
      let nextlyLink = document.querySelector(`a[href="${res}"]`)
      const token = getCookie('userToken');
      (nextlyLink && token) ? nextlyLink.href = `${res}/?userToken=${token}` : null
    })
    .catch(e => {
      console.error('Error fetching nextly link: ', e);
    })
})
